var _defs, _circle, _path, _path2, _path3, _path4, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    viewBox: "0 0 649.1 627.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:none;stroke-miterlimit:10;}.cls-1{stroke:#000;stroke-width:29px;}.cls-2{stroke:#39b54a;}.cls-2,.cls-3,.cls-4,.cls-5{stroke-width:49px;}.cls-3{stroke:#fbb03b;}.cls-4{stroke:#ed1c24;}.cls-5,.cls-6{stroke:#0071bc;}.cls-6{stroke-width:59px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 224.8,
    cy: 224.58,
    r: 200
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M932.2,600.37c-110.45,0-200-89.54-200-200",
    transform: "translate(-707.7 -175.92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M732.2,400.42c0-110.46,89.55-200,200-200",
    transform: "translate(-707.7 -175.92)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M932.16,200.42c110.46,0,200,89.54,200,200",
    transform: "translate(-707.7 -175.92)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1132.16,400.37c0,110.46-89.54,200-200,200",
    transform: "translate(-707.7 -175.92)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 364.98,
    y1: 366.76,
    x2: 629.3,
    y2: 606.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSearchIcon);
export default __webpack_public_path__ + "static/media/google-search-icon.9d53842cc4dd2fda85ed0a5dc010793c.svg";
export { ForwardRef as ReactComponent };